<script setup>
import { ensureRef } from '@/common/util'
import ManExtApi from '@/components/admin/data/ManExtApi.vue'
import ManLayer from '@/components/admin/data/ManLayer.vue'
import ManMemo from '@/components/admin/data/ManMemo.vue'
import ManObjdetect from '@/components/admin/data/ManObjdetect.vue'
import ManStreetView from '@/components/admin/data/ManStreetView.vue'
import ManStyle from '@/components/admin/data/ManStyle.vue'
import AdmLayout from '@/pages/layout/AdmLayout.vue'
import { useMetaStore } from '@/stores'
import _ from 'lodash-es'
import { ref } from 'vue'
import { useRoute } from 'vue-router'
const submenus=ref(['managelayers','objectdetection','managestyles','registermanageroadview','manageroadviewnotes','man_ext_api']),route=useRoute(),admLayout=ref(null)
  ,inited=ref(false),metaStore=useMetaStore()
function init(){
  if(metaStore.dispmode=='minimum'){
    _.remove(submenus.value,item=>item=='man_ext_api')
  }
  inited.value=true
}
init()
</script>
<template>
  <AdmLayout v-if="inited" ref="admLayout" menutk="managedata" :submenus="submenus">
    <v-tabs-window-item v-for="sm in submenus" :value="sm" class="h-100">
      <ManLayer v-if="sm=='managelayers'"/>
      <ManObjdetect v-if="sm=='objectdetection'"/>
      <ManStyle v-if="sm=='managestyles'"/>
      <ManStreetView v-if="sm=='registermanageroadview'"/>
      <ManMemo v-if="sm=='manageroadviewnotes'"/>
      <ManExtApi v-if="sm=='man_ext_api'"/>
    </v-tabs-window-item>
  </AdmLayout>
</template>
